import Vue from 'vue'
import Vuex from 'vuex'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)



export default new Vuex.Store({

})



// WEBPACK FOOTER //
// ./src/store/index.js